import { DeleteOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import React from "react";
import { DAYS_ENG_TO_THAI, THAI_DAY } from "utils/constants";
export default function CardLeaveSetup({
  setTfDate,
  isHolliday,
  setIsHolliday,
  setStartTime,
  setEndTime,
  setEditId,
  data,
  userData,
  selectStatus,
  setIsCreate,
  formRef,
  setSelectedDelete,
  setLeaveDateSelect,
  setIsSpecific,
}) {
  const profile_image = (userData?.file_uploads || []).find(
    (file) => file.type === "profile"
  );

  function onClickEdit() {
    setIsCreate(true);
    setEditId(data.id);

    let recurring_number_list = data?.is_specific_date
      ? []
      : data?.recurring_days?.map((day) =>
          THAI_DAY.findIndex((thd) => thd.prefix_day_name_en === day)
        ) ?? [];

    setStartTime(dayjs(data.start_time).subtract(7, "hours").format("HH:mm"));
    setEndTime(dayjs(data.end_time).subtract(7, "hours").format("HH:mm"));
    setIsHolliday(data.is_holiday);
    setTfDate(dayjs(data.date).format("YYYY-MM-DD"));
    setLeaveDateSelect(recurring_number_list);
    setIsSpecific(data.is_specific_date);

    setTimeout(() => {
      formRef.current.setFieldsValue({
        date: dayjs(data.date),
        start_time:
          !data.is_holiday && data.start_time
            ? dayjs(data.start_time).subtract(7, "hours")
            : null,
        end_time:
          !data.is_holiday && data.end_time
            ? dayjs(data.end_time).subtract(7, "hours")
            : null,
        is_holiday: data.is_holiday,
        is_specific: data.is_specific_date,
      });
    }, 200);
  }

  return (
    <div
      className="leave-card-container"
      style={{
        position: "relative",
        cursor: selectStatus === "รายการวันหยุด" ? "pointer" : "not-allowed",
      }}
    >
      <div
        // onClick={() => onClickEdit()}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundImage: `url(${
                profile_image?.image_url || "/default-profile.png"
              })`,
              borderRadius: "50%",
              width: 50,
              height: 50,
            }}
          />
          <b>
            {!data.is_specific_date
              ? isHolliday && data?.recurring_days.length === 0
                ? dayjs(data.date).format("DD MMMM YYYY")
                : data?.recurring_days
                    ?.map((day) => DAYS_ENG_TO_THAI[day])
                    .join(", ")
              : dayjs(data.date).format("DD MMMM YYYY")}
          </b>
        </div>
        {isHolliday ? (
          <b
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "center",
              color: selectStatus === "รายการวันหยุด" ? "red" : "#979797",
            }}
          >
            วันหยุด
          </b>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 10,
              alignItems: "center",
              color: selectStatus === "รายการวันหยุด" ? "red" : "#979797",
            }}
          >
            <b>
              {dayjs(data.start_time).subtract(7, "hours").format("HH:mm")} -{" "}
              {dayjs(data.end_time).subtract(7, "hours").format("HH:mm")}
            </b>
            <b>ระยะเวลาหยุด</b>
          </div>
        )}
      </div>

      {selectStatus === "รายการวันหยุด" && userData.register_state === 2 && (
        <div
          onClick={() => setSelectedDelete(data)}
          style={{
            position: "absolute",
            right: -10,
            top: -10,
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "red",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DeleteOutlined />
        </div>
      )}
    </div>
  );
}
